import React, { ReactNode } from 'react';
import Link from 'next/link';
import { defineMessages, useIntl } from 'react-intl';
import classNames from 'classnames';
import { APIPaginationProps } from '../../components/APIPagination';
import { nextAsset } from '../../components/nextAsset';

const { paginationNewer, paginationOlder } = defineMessages({
  paginationNewer: {
    id: 'sml.web.blog.list.pagination.newer',
    defaultMessage: 'Newer'
  },
  paginationOlder: {
    id: 'sml.web.blog.list.pagination.oler',
    defaultMessage: 'Older Posts'
  }
});
const PrevElement: React.FC<{ disabled?: boolean; href?: string }> = ({ disabled, href }) => {
  const intl = useIntl();
  return (
    <a href={href} className={classNames('blog-pagination-newer d-none d-md-inline', { disabled })}>
      <img
        src={nextAsset('images/arrow-left-bold-light.svg')}
        alt={intl.formatMessage(paginationNewer)}
        title={intl.formatMessage(paginationNewer)}
        className="me-3"
      />{' '}
      <span>{intl.formatMessage(paginationNewer)}</span>
    </a>
  );
};
const NextElement: React.FC<{ disabled?: boolean; href?: string }> = ({ disabled, href }) => {
  const intl = useIntl();
  return (
    <a href={href} className={classNames('blog-pagination-older d-none d-md-inline', { disabled })}>
      <span>{intl.formatMessage(paginationOlder)}</span>{' '}
      <img
        src={nextAsset('images/arrow-right-bold-light.svg')}
        alt={intl.formatMessage(paginationOlder)}
        title={intl.formatMessage(paginationOlder)}
        className="ms-3"
      />
    </a>
  );
};

export const BlogPagination: React.FC<APIPaginationProps> = ({ total, limit, page, getURL }) => {
  const totalPages = Math.ceil(total / limit);

  if (totalPages <= 1) {
    return null;
  }
  const pages: ReactNode[] = [];

  for (let i = 0; i < totalPages; i += 1) {
    const url = getURL(i);
    pages.push(
      <Link key={i} href={url.href} as={url.as} passHref>
        <a className={i === page ? '' : 'muted'}>{`${i + 1}`}</a>
      </Link>
    );
  }

  const prevURL = getURL(page - 1);
  const nextURL = getURL(page + 1);
  const isPrevAvailable = page !== 0;
  const isNextAvailable = page !== totalPages - 1;

  return (
    <div className="blog-pagination">
      {isPrevAvailable ? (
        <Link href={prevURL.href} as={prevURL.as} passHref>
          <PrevElement />
        </Link>
      ) : (
        <PrevElement disabled />
      )}
      <div className="blog-pagination-info">{pages}</div>
      {isNextAvailable ? (
        <Link href={nextURL.href} as={nextURL.as} passHref>
          <NextElement />
        </Link>
      ) : (
        <NextElement disabled />
      )}
    </div>
  );
};
